import React, { useState } from "react";
import { paymentStatusQuery, useSubmit } from "../../../../api";
import BaseModal from "../../../BaseModal/BaseModal";
import { Alert, Form, Select, Spin } from "antd";
import { fieldNames } from "./constants";
import { useSetModalVisible } from "../../../../model/modalState";
import FetchError from "../../../FetchError/FetchError";
import InformationBlockModal from "../../../InformationBlockModal/InformationBlockModal";
import { typeMassActionsText } from "../../../InformationBlockModal/constants";
import { useDispatch } from "react-redux";
import { requestListActions } from "../../../../../../request-list.actions";

const { useFetch: usePaymentStatus } = paymentStatusQuery;
const { Item: FormItem, create: createForm } = Form;
const { Option } = Select;

const ErrorContent = ({ refetch }) => {
  return (
    <FetchError
      msg="Не удалось получить список мастеров"
      onClick={() => refetch()}
    />
  );
};

const Container = ({ form, requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const dispatch = useDispatch();

  const { data, isFetching, refetch } = usePaymentStatus(
    {
      staleTime: Infinity,
      notifyOnChangeProps: ['data', 'isFetching'],
    }
  );

  const setModalVisible = useSetModalVisible();
  const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const { submitAsync, loading } = useSubmit({
    url: '/Request/set_payment_state',
    errMsg: 'Не удалось изменить статус оплаты у выбранных заявок',
    onSuccess,
  });

  const isError = data === 'Error';

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = {
          PaymentStateId: values.paymentStatus,
        }
          setValue(value);
          setStateInfo(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
      e.preventDefault()
  
      try {
        await submitAsync({
          ids: requests.map(({ id }) => id),
          value,
          requests,
        });
  
        setModalVisible(false);
        setStateInfo(false);
        dispatch(requestListActions.setSelected([]));
        resetFields();
      } catch(error) {
        return <Alert title={error.message} />
      }
    }
  
  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  return (
    <BaseModal
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      title={stateInfo ? "Подтвердите изменения" : 'Изменение статуса оплаты'}
      confirmLoading={loading}
      width={stateInfo ? 600 : 450}
    >
      <Spin spinning={Boolean(isFetching)}>
        {isError ? (
          <ErrorContent refetch={refetch} />
        ) : (
          !stateInfo ? (
            <Form>
              <FormItem label="Статус оплаты">
                {getFieldDecorator(fieldNames.paymentStatus, {
                  rules: [
                    {
                      required: true,
                      message: 'Выберите статус оплаты',
                    },
                  ],
                })(
                  <Select
                    placeholder="Выберите статус оплаты"
                  >
                    {data?.paymentState?.map((status) => (
                      <Option value={status.id} key={status.id}>{status.name}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Form>
           ) : (
            <InformationBlockModal typeMassActions={typeMassActionsText.paymentStatus} count={requests.length} />
          )
        )}
      </Spin>
    </BaseModal>
  )
}

const ChangePaymentStatus = createForm({
  name: 'mass_actions_payment_state',
})(Container);

export default ChangePaymentStatus;
